import { BATTLESHIP } from 'visitor-ui-component-library/constants/WidgetColors';
import I18n from 'I18n';
import styled from 'styled-components';
import SVGSend from 'visitor-ui-component-library-icons/icons/SVGSend';
import { hexToRGB } from 'visitor-ui-component-library/utils/hexToRGB';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = styled.button.withConfig({
  displayName: "SendButton__Button",
  componentId: "sc-91bin2-0"
})(["border:none;padding:0;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;outline:none;background-color:", ";color:", ";transition:background-color 150ms ease-out;font-size:18px;&:hover:enabled{background-color:rgba( ", ",0.9 );}&:focus-visible{outline-offset:1px;outline:2px solid #00a4bd;}&[disabled]{cursor:not-allowed;background-color:transparent;color:", ";}"], ({
  theme
}) => theme.colors.primary, ({
  theme
}) => theme.colors.textOnPrimary, ({
  theme
}) => Object.values(hexToRGB(theme.colors.primary)).join(', '), BATTLESHIP);
const SendIcon = styled(SVGSend).withConfig({
  displayName: "SendButton__SendIcon",
  componentId: "sc-91bin2-1"
})(["width:1em;height:1em;fill:currentColor;"]);
export function SendButton(props) {
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.send'),
    "data-test-id": "chat-send-button"
  }, props, {
    children: /*#__PURE__*/_jsx(SendIcon, {})
  }));
}
SendButton.displayName = 'SendButton';